import api from './api';

export const getLicenseUsage = () => api.get('/v1/licenses/usage');
export const getLicenseSeats = (moduleCode, params) =>
  api.get(`/v1/licenses/${moduleCode}/seats?${new URLSearchParams(params)}`);
export const getLicenseRule = (moduleCode) => api.get(`/v1/licenses/${moduleCode}/rule`);
export const updateLicenseRule = (moduleCode, data) => api.put(`/v1/licenses/${moduleCode}/rule`, data);
// P4Kü-5 — kuralı kaldırmanın AÇIK ucu. Eskiden "boş gövdeyle PUT" örtük sözleşmesiydi: çekmece
// kuralı yüklemeden (ya da GET başarısızken) kaydedince havuzun TÜM kural koltukları iade
// ediliyordu. Boş gövdeli PUT artık 400 `license.ruleEmpty` döner.
export const deleteLicenseRule = (moduleCode) => api.delete(`/v1/licenses/${moduleCode}/rule`);
export const previewLicenseRule = (moduleCode, data) =>
  api.post(`/v1/licenses/${moduleCode}/rule/preview`, data);
export const grantLicenseSeat = (moduleCode, data) => api.post(`/v1/licenses/${moduleCode}/seats`, data);
export const revokeLicenseSeat = (moduleCode, userId) =>
  api.delete(`/v1/licenses/${moduleCode}/seats/${userId}`);
